import React from 'react';

import { Icon, SimpleTooltip } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export interface PreviewGenerationStatsProps {
  durationMs: number;
  inputTokens?: number;
  outputTokens?: number;
}

const formatDuration = (ms: number): string =>
  ms < 1000 ? `${Math.round(ms)} ms` : `${(ms / 1000).toFixed(1)} s`;

/** Footer under a generated preview: generation time and token usage. */
export const PreviewGenerationStats: React.FC<PreviewGenerationStatsProps> = ({
  durationMs,
  inputTokens,
  outputTokens,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-2 flex items-center gap-2 border-t border-border-primary/60 pt-3 text-xs text-text-tertiary">
      <Icon name="Clock" size="xs" />
      <span>
        {t('outputTemplates.workspace.generatedIn', {
          duration: formatDuration(durationMs),
        })}
      </span>
      {inputTokens !== undefined && outputTokens !== undefined && (
        <>
          <span aria-hidden>·</span>
          <SimpleTooltip
            label={t('outputTemplates.workspace.tokenBreakdown', {
              input: inputTokens.toLocaleString(),
              output: outputTokens.toLocaleString(),
            })}
          >
            <span>
              {t('outputTemplates.workspace.tokenCount', {
                count: (inputTokens + outputTokens).toLocaleString(),
              })}
            </span>
          </SimpleTooltip>
        </>
      )}
    </div>
  );
};
